import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '@components/atoms/LoadingSpinner';
import { SenderAddressForm } from '@components/organisms/SenderAddressForm';
import { useSample } from '@hooks/useSample';
import { Paths } from '@src/routes/paths';

export const AddSenderAddressView = () => {
  const { t } = useTranslation('view', { keyPrefix: 'senderAddress' });
  const navigate = useNavigate();

  const { data: sample, isLoading } = useSample();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!sample) {
    navigate(Paths.PROFILE);
    return null;
  }

  return (
    <div>
      <h1>{t('title')}</h1>
      <SenderAddressForm sample={sample} />
    </div>
  );
};
